export { default } from './SectionRelatedPosts';